import React from "react";

const CopyIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66667 13.8333H4.16667C3.72464 13.8333 3.30072 13.6577 2.98816 13.3452C2.67559 13.0326 2.5 12.6087 2.5 12.1667V4.66667C2.5 4.22464 2.67559 3.80072 2.98816 3.48816C3.30072 3.17559 3.72464 3 4.16667 3H11.6667C12.1087 3 12.5326 3.17559 12.8452 3.48816C13.1577 3.80072 13.3333 4.22464 13.3333 4.66667V7.16667"
        stroke="#7E7E7E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="6.66663"
        y="7.16667"
        width="10.8333"
        height="10.8333"
        rx="1.66667"
        stroke="#7E7E7E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CopyIcon;
